import React, { useEffect, useState, useCallback } from "react";
import { Plus, Trash2, Edit2, ChevronDown, ChevronUp } from "lucide-react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiUrl from "../Environment/ApiUrl";

const UpdateSales = () => {
  const { Sales_ID } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [expandedCategories, setExpandedCategories] = useState({});
  const [searchQuery, setSearchQuery] = useState("");

  const [stockData, setStockData] = useState([]);
  const [categoryTableData, setCategoryTableData] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentEditIndex, setPaymentEditIndex] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [generatedData, setGeneratedData] = useState("");
  const [originalSalesItems, setOriginalSalesItems] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [isGstDisabled, setIsGstDisabled] = useState(false);

  const [salesData, setSalesData] = useState({
    Sales_ID: Sales_ID || "",
    Purchase_Date: new Date().toISOString().split("T")[0],
    Sub_Total: "0.00",
    Gst_Amount: "0.00",
    Net_total: "0.00",
    Paid_Amount: "0.00",
    GSTIN: "",
    name: "",
    mobile_number: "",
    balance: "0.00",
  });

  const [salesItems, setSalesItems] = useState([]);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [paymentForm, setPaymentForm] = useState({
    Date: new Date().toISOString().split("T")[0],
    Pay_Type: "",
    Amount: "",
  });

  const [productData, setProductData] = useState({
    hsn_code: "",
    category: "",
    subcategory: "",
    vehicle_type: "",
    branch_name: "Default Branch",
    brand_name: "",
    type: "",
    tyre_size: "",
    status: "Active",
    purchase_rate: "",
    gst: "",
    available_quantity: "",
    mrp: "",
  });

  const [formErrors, setFormErrors] = useState({
    sales_quantity: "",
    Mrp: "",
    sales_gst: "",
    tyre_number: "",
    Purchase_Date: "",
    name: "",
  });

  const debouncedSetSearchQuery = debounce((value) => {
    setSearchQuery(value);
  }, 300);

  const handleSearchChange = (e) => {
    debouncedSetSearchQuery(e.target.value);
  };

  const validateHsnCode = (hsnCode) => {
    if (!hsnCode || hsnCode.trim() === "") return false;
    const hsnRegex = /^[A-Z0-9-]+$/;
    return hsnRegex.test(hsnCode);
  };

  const fetchNextProductId = async (retries = 3, delay = 1000) => {
    setIsLoading(true);
    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        const response = await axios.get(
          `${ApiUrl}/product_data.php/generate-product-code`,
          { timeout: 5000 }
        );
        console.log("Product ID API Response:", response.data);

        if (!response.data) {
          throw new Error("No data received from product ID API");
        }

        const hsnCode =
          response.data.hsn_code ||
          response.data.HSN_code ||
          response.data.HSN_CODE;
        if (!validateHsnCode(hsnCode)) {
          throw new Error(
            "Invalid product ID response: Missing or invalid hsn_code"
          );
        }

        setGeneratedData(hsnCode);
        setProductData((prev) => ({
          ...prev,
          hsn_code: hsnCode,
        }));
        setIsLoading(false);
        return;
      } catch (error) {
        console.error(`Attempt ${attempt} failed:`, {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status,
        });

        if (attempt === retries) {
          const tempHsnCode = `TEMP-${Date.now()}`;
          setGeneratedData(tempHsnCode);
          setProductData((prev) => ({
            ...prev,
            hsn_code: tempHsnCode,
          }));
          toast.warn(
            "Failed to fetch product ID after retries, using temporary HSN code"
          );
          setIsLoading(false);
        } else {
          await new Promise((resolve) => setTimeout(resolve, delay));
        }
      }
    }
  };

  const validateSalesItemForm = (item) => {
    const errors = {};
    if (
      item.tyre_numbers.length !== item.sales_quantity ||
      item.tyre_numbers.some((n) => !n.trim())
    )
      errors.tyre_number = "All tyre numbers are required";
    if (
      !item.sales_quantity ||
      isNaN(item.sales_quantity) ||
      Number(item.sales_quantity) <= 0
    )
      errors.sales_quantity = "Quantity must be a positive number";
    if (!item.Mrp || isNaN(item.Mrp) || Number(item.Mrp) <= 0)
      errors.Mrp = "MRP must be a positive number";
    if (!item.sales_gst || isNaN(item.sales_gst) || Number(item.sales_gst) < 0)
      errors.sales_gst = "GST must be a non-negative number";
    if (!item.hsn_code || !validateHsnCode(item.hsn_code))
      errors.hsn_code = "Valid HSN code is required";
    return errors;
  };


  // const calculateSubtotal = () => {
  //   return salesItems.reduce((total, item) => {
  //     const gstRate = parseFloat(item.sales_gst || 0) / 100;
  //     const mrpIncludingGst = parseFloat(item.Mrp || 0);
  //     const basePrice = mrpIncludingGst * (1 - gstRate);
  //     return total + parseFloat(item.sales_quantity || 0) * basePrice;
  //   }, 0);
  // };

  const calculateSubtotal = () => {
    return salesItems.reduce((total, item) => {
      const gstRate = parseFloat(item.sales_gst || 0) / 100;
      const mrpIncludingGst = parseFloat(item.Mrp || 0);
      const baseMrp1 = (mrpIncludingGst * (1 + gstRate)).toFixed(2);
      const baseMrp2 = (baseMrp1 - mrpIncludingGst).toFixed(2);
      const baseMrp = (mrpIncludingGst - baseMrp2).toFixed(2);
      return total + parseFloat(item.sales_quantity || 0) * baseMrp;
    }, 0);
  };





  const calculateGstAmount = () => {
    if (isGstDisabled) return 0;
    return salesItems.reduce((total, item) => {
      const gstRate = parseFloat(item.sales_gst || 0) / 100;
      const mrpIncludingGst = parseFloat(item.Mrp || 0);
      const baseMrp1 = (mrpIncludingGst * (1 + gstRate)).toFixed(2);
      const basePrice = mrpIncludingGst / (1 + gstRate);
      const gstAmount = baseMrp1 - mrpIncludingGst;
      return total + parseFloat(item.sales_quantity || 0) * gstAmount;
    }, 0);
  };

  // const calculateGstAmount = () => {
  //   if (isGstDisabled) return 0;
  //   return salesItems.reduce((total, item) => {
  //     const gstRate = parseFloat(item.sales_gst || 0) / 100;
  //     const mrpIncludingGst = parseFloat(item.Mrp || 0);
  //     const gstAmount = mrpIncludingGst * gstRate;
  //     return total + parseFloat(item.sales_quantity || 0) * gstAmount;
  //   }, 0);
  // };

  const calculateNetTotal = () => {
    return salesItems.reduce((total, item) => {
      const mrpIncludingGst = parseFloat(item.Mrp || 0);
      return total + parseFloat(item.sales_quantity || 0) * mrpIncludingGst;
    }, 0);
  };

  useEffect(() => {
    calculateNetTotal()
  }, []);

  useEffect(() => {

  }, [salesItems, paymentHistory, isGstDisabled]);

  useEffect(() => {
    const fetchData = async () => {
      if (!Sales_ID) {
        setError("Missing or invalid Sales ID");
        toast.error("Missing or invalid Sales ID");
        navigate("/sales");
        return;
      }
      setIsLoading(true);
      setError(null);
      try {

        const stockResponse = await axios.get(`${ApiUrl}/stock_data.php`);
        if (!stockResponse.data?.data) {
          throw new Error("Invalid stock data response");
        }
        const fetchedStock = Array.isArray(stockResponse.data.data)
          ? stockResponse.data.data.map((item) => ({
            ...item,
            hsn_code: item.hsn_code || item.HSN_code,
            Mrp: item.Mrp || item.mrp || "0.00",
          }))
          : [];
        setStockData(fetchedStock);

        const categoriesMap = {};
        fetchedStock.forEach((item) => {
          if (item.category) {
            if (!categoriesMap[item.category])
              categoriesMap[item.category] = new Set();
            if (item.subcategory) {
              item.subcategory
                .split(",")
                .map((subCat) => subCat.trim())
                .forEach((subCat) => categoriesMap[item.category].add(subCat));
            }
          }
        });
        const categoryData = Object.keys(categoriesMap).map((category) => ({
          category,
          subcategories: Array.from(categoriesMap[category]),
        }));
        setCategoryTableData(categoryData);

        setQuantities(
          fetchedStock.reduce(
            (acc, item) => ({
              ...acc,
              [`${item.hsn_code}|${item.category}|${item.subcategory}`]: 0,
            }),
            {}
          )
        );

        const salesResponse = await axios.get(
          `${ApiUrl}/sales_data.php?Sales_ID=${Sales_ID}`
        );
        console.log("salesResponse", salesResponse);
        if (!salesResponse.data?.data) {
          throw new Error("No sales data found for the provided Sales_ID");
        }
        const sales = salesResponse.data.data.find(
          (sale) => sale.Sales_ID === Sales_ID
        );
        if (!sales) {
          throw new Error(`No sales data found for Sales_ID: ${Sales_ID}`);
        }
        const calculatedBalance = (
          parseFloat(sales.Net_total || 0) - parseFloat(sales.Paid_Amount || 0)
        ).toFixed(2);
        setSalesData({
          Sales_ID: sales.Sales_ID || "",
          Purchase_Date: sales.Purchase_Date
            ? new Date(sales.Purchase_Date).toISOString().split("T")[0]
            : new Date().toISOString().split("T")[0],
          Sub_Total: parseFloat(sales.Sub_Total || 0).toFixed(2),
          Gst_Amount: parseFloat(sales.Gst_Amount || 0).toFixed(2),
          Net_total: parseFloat(sales.Net_total || 0).toFixed(2),
          Paid_Amount: parseFloat(sales.Paid_Amount || 0).toFixed(2),
          GSTIN: sales.GSTIN || "",
          name: sales.name || "",
          mobile_number: sales.mobile_number || "",
          balance: calculatedBalance,
        });

        const mappedItems =
          sales.Sales_Items?.map((item) => {
            let tyreNums = item.tyre_number
              ? item.tyre_number.split(",").map((t) => t.trim())
              : [];
            const qty = parseInt(item.sales_quantity, 10) || 0;
            if (tyreNums.length < qty) {
              tyreNums = [
                ...tyreNums,
                ...Array(qty - tyreNums.length).fill(""),
              ];
            } else if (tyreNums.length > qty) {
              tyreNums = tyreNums.slice(0, qty);
            }
            return {
              id: item.id || Date.now().toString(),
              Sales_ID: item.Sales_ID || Sales_ID,
              branch_name: item.branch_name || "Default Branch",
              category: item.category || "N/A",
              sub_category: item.sub_category || "N/A",
              vehicle_type: item.vehicle_type || "N/A",
              type: item.type || "N/A",
              tyre_size: item.tyre_size || "N/A",
              hsn_code: item.HSN_code || item.hsn_code || `TEMP-${Date.now()}`,
              sales_quantity: qty,
              sales_rate: parseFloat(item.sales_rate) || 1000,
              sales_gst: parseFloat(item.sales_gst) || 18,
              tyre_numbers: tyreNums,
              Mrp: parseFloat(item.Mrp || item.mrp || "0.00"),
            };
          }) || [];
        console.log("Mapped Sales Items:", mappedItems);
        setSalesItems([]); // Reset to avoid accumulation
        setSalesItems(mappedItems);
        setOriginalSalesItems([...mappedItems]);

        setQuantities((prev) => ({
          ...prev,
          ...mappedItems.reduce(
            (acc, item) => ({
              ...acc,
              [`${item.hsn_code}|${item.category}|${item.sub_category}`]:
                item.sales_quantity || 0,
            }),
            {}
          ),
        }));

        const hasGstRates = mappedItems.some(
          (item) => parseFloat(item.sales_gst) > 0
        );
        setIsGstDisabled(parseFloat(sales.Gst_Amount) === 0 && hasGstRates);

        const paymentResponse = await axios.get(
          `${ApiUrl}/sales_payment_history.php?Sales_ID=${Sales_ID}`
        );
        if (paymentResponse.data?.status) {
          const mappedPayments =
            paymentResponse.data.Payment_History?.map((payment) => ({
              id: payment.id || Date.now().toString(),
              Sales_ID: payment.Sales_ID || Sales_ID,
              Date: payment.Date || new Date().toISOString().split("T")[0],
              Pay_Type: payment.Pay_Type || "",
              Amount: parseFloat(payment.Amount || 0).toFixed(2),
            })) || [];
          setPaymentHistory(mappedPayments);
        } else {
          setPaymentHistory([]);
          toast.warn("No payment history found for this Sales_ID");
        }

        const subTotal = mappedItems.reduce((sum, item) => {
          const gstRate = isGstDisabled ? 0 : (Number(item.sales_gst) || 0) / 100;
          const basePrice = (Number(item.Mrp) || 0) / (1 + gstRate);
          return sum + (Number(item.sales_quantity) || 0) * basePrice;
        }, 0);
        const gstAmount = parseFloat(sales.Gst_Amount || 0);
        const netTotal = subTotal + gstAmount;
        const paidAmount =
          paymentResponse.data?.Payment_History?.reduce(
            (sum, payment) => sum + (Number(payment.Amount) || 0),
            0
          ) || 0;
        const balance = netTotal - paidAmount;
        console.log("Initial Balance Calculation:", {
          subTotal,
          gstAmount,
          netTotal,
          paidAmount,
          balance,
        });

        setSalesData((prev) => ({
          ...prev,
          balance: balance.toFixed(2),
        }));

        if (showModal) {
          await fetchNextProductId();
        }
      } catch (error) {
        console.error("Fetch error details:", {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status,
        });
        setError(error.message || "Failed to fetch initial data");
        toast.error(error.message || "Failed to fetch initial data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [Sales_ID, navigate, showModal]);

  const toggleCategory = (category) => {
    setExpandedCategories((prev) => ({ ...prev, [category]: !prev[category] }));
  };



  const handleSalesDataChange = (e) => {
    const { name, value } = e.target;
    setSalesData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleQuantityChange = useCallback(
    (item, action) => {
      setQuantities((prev) => {
        const itemKey = `${item.hsn_code}|${item.category}|${item.subcategory}`;
        const newQuantities = { ...prev };
        const currentQuantity = newQuantities[itemKey] || 0;
        const availableQuantity = parseInt(item.available_quantity, 10) || 0;
        const newQuantity =
          action === "increase"
            ? currentQuantity + 1
            : Math.max(0, currentQuantity - 1);

        if (action === "increase" && newQuantity > availableQuantity) {
          toast.error(
            `Cannot add more. Available quantity for ${item.tyre_size} is ${availableQuantity}.`
          );
          return prev;
        }

        newQuantities[itemKey] = newQuantity;

        setSalesItems((prevItems) => {
          const existingItemIndex = prevItems.findIndex(
            (pi) =>
              pi.hsn_code === item.hsn_code &&
              pi.category === item.category &&
              pi.sub_category === item.subcategory
          );
          const existingItem =
            existingItemIndex >= 0 ? prevItems[existingItemIndex] : null;
          let newTyreNumbers = existingItem
            ? [...existingItem.tyre_numbers]
            : Array(newQuantity).fill("");
          if (existingItem && newQuantity > existingItem.sales_quantity) {
            const diff = newQuantity - existingItem.sales_quantity;
            newTyreNumbers = [...newTyreNumbers, ...Array(diff).fill("")];
          } else if (
            existingItem &&
            newQuantity < existingItem.sales_quantity
          ) {
            newTyreNumbers = newTyreNumbers.slice(0, newQuantity);
          }
          const newItem = {
            id:
              existingItemIndex >= 0
                ? prevItems[existingItemIndex].id
                : Date.now().toString(),
            Sales_ID: salesData.Sales_ID,
            branch_name: item.branch_name || "Default Branch",
            category: item.category || "N/A",
            sub_category: item.subcategory || "N/A",
            vehicle_type: item.vehicle_type || "N/A",
            type: item.type || "N/A",
            tyre_size: item.tyre_size || "N/A",
            hsn_code: item.hsn_code || `TEMP-${Date.now()}`,
            sales_quantity: newQuantity,
            sales_rate: parseFloat(item.purchase_rate) || 1000,
            sales_gst: parseFloat(item.gst) || 18,
            tyre_numbers: newTyreNumbers,
            Mrp: parseFloat(item.Mrp || "0.00"),
          };
          let updatedItems;
          if (newQuantity === 0) {
            updatedItems = prevItems.filter((_, i) => i !== existingItemIndex);
          } else if (existingItemIndex >= 0) {
            updatedItems = [...prevItems];
            updatedItems[existingItemIndex] = newItem;
          } else {
            updatedItems = [...prevItems, newItem];
          }
          console.log("Updated Sales Items:", updatedItems);
          return updatedItems;
        });

        return newQuantities;
      });
    },
    [salesData.Sales_ID]
  );

  const handleSalesItemChange = (index, field, value) => {
    setSalesItems((prevItems) => {
      const updatedItems = [...prevItems];
      const item = updatedItems[index];
      if (field === "sales_quantity") {
        const newQty = parseInt(value, 10) || 0;
        const stockItem = stockData.find(
          (stock) => stock.hsn_code === item.hsn_code
        );
        if (stockItem && newQty > parseInt(stockItem.available_quantity, 10)) {
          toast.error(
            `Quantity cannot exceed available stock (${stockItem.available_quantity})`
          );
          return prevItems;
        }
        let newTyreNumbers = [...item.tyre_numbers];
        if (newQty > item.sales_quantity) {
          const diff = newQty - item.sales_quantity;
          newTyreNumbers = [...newTyreNumbers, ...Array(diff).fill("")];
        } else if (newQty < item.sales_quantity) {
          newTyreNumbers = newTyreNumbers.slice(0, newQty);
        }
        updatedItems[index] = {
          ...item,
          sales_quantity: newQty,
          tyre_numbers: newTyreNumbers,
        };
        setQuantities((prev) => ({
          ...prev,
          [`${item.hsn_code}|${item.category}|${item.sub_category}`]: newQty,
        }));
      } else {
        updatedItems[index] = { ...item, [field]: value };
      }
      setEditIndex(index);
      const errors = validateSalesItemForm(updatedItems[index]);
      setFormErrors((prev) => ({ ...prev, ...errors }));
      return updatedItems;
    });
  };

  const calculatePaidAmount = () => {
    return paymentHistory.reduce((sum, payment) => sum + parseFloat(payment.Amount || 0), 0);
  };

  useEffect(() => {
    const subTotal = calculateSubtotal().toFixed(2);
    const gstAmount = calculateGstAmount().toFixed(2);
    const netTotal = calculateNetTotal().toFixed(2);
    const paidAmount = calculatePaidAmount().toFixed(2);
    const balance = (parseFloat(netTotal) - parseFloat(paidAmount)).toFixed(2);

    setSalesData((prev) => ({
      ...prev,
      Sub_Total: subTotal,
      Gst_Amount: gstAmount,
      Net_total: netTotal,
      Paid_Amount: paidAmount,
      balance: balance,
    }));
  }, [salesItems, paymentHistory, isGstDisabled]);

  const handleTyreNumberChange = (index, tyreIdx, value) => {
    setSalesItems((prevItems) => {
      const updatedItems = [...prevItems];
      const item = { ...updatedItems[index] };
      const newTyreNumbers = [...item.tyre_numbers];
      newTyreNumbers[tyreIdx] = value;
      item.tyre_numbers = newTyreNumbers;
      updatedItems[index] = item;
      const errors = validateSalesItemForm(item);
      setFormErrors((prev) => ({ ...prev, ...errors }));
      return updatedItems;
    });
  };

  const handleEditSalesItem = (index) => {
    const item = salesItems[index];
    const stockItem = stockData.find(
      (stock) => stock.hsn_code === item.hsn_code
    );
    if (
      stockItem &&
      item.sales_quantity > parseInt(stockItem.available_quantity, 10)
    ) {
      toast.error(
        `Cannot edit. Available quantity for ${item.tyre_size} is ${stockItem.available_quantity}.`
      );
      return;
    }
    setEditIndex(index);
    setSalesItems((prevItems) => [...prevItems]);
  };

  const handleDeleteSalesItem = (index) => {
    const item = salesItems[index];
    setSalesItems((prevItems) => {
      const updatedItems = prevItems.filter((_, i) => i !== index);
      return updatedItems;
    });
    setQuantities((prev) => ({
      ...prev,
      [`${item.hsn_code}|${item.category}|${item.sub_category}`]: 0,
    }));
  };

  const handleGstCheckboxChange = (e) => {
    setIsGstDisabled(e.target.checked);
  };

  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    setPaymentForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddPayment = async () => {
    if (!paymentForm.Pay_Type || !paymentForm.Amount || !paymentForm.Date) {
      toast.error("Please fill all payment fields");
      return;
    }

    if (isNaN(paymentForm.Amount) || Number(paymentForm.Amount) <= 0) {
      toast.error("Payment amount must be a positive number");
      return;
    }

    const newPayment = {
      id:
        paymentEditIndex !== null
          ? paymentHistory[paymentEditIndex].id
          : Date.now().toString(),
      Sales_ID: salesData.Sales_ID,
      Date: paymentForm.Date,
      Pay_Type: paymentForm.Pay_Type,
      Amount: parseFloat(paymentForm.Amount).toFixed(2),
    };

    const netTotal = Number(salesData.Net_total);
    const currentPaidAmount = paymentHistory.reduce(
      (sum, payment) => sum + Number(payment.Amount || 0),
      0
    );
    const newPaidAmount =
      paymentEditIndex !== null
        ? currentPaidAmount -
        Number(paymentHistory[paymentEditIndex]?.Amount || 0) +
        Number(paymentForm.Amount)
        : currentPaidAmount + Number(paymentForm.Amount);

    if (newPaidAmount > netTotal) {
      toast.error(
        `Paid Amount (${newPaidAmount.toFixed(
          2
        )}) cannot exceed Net Total (${netTotal.toFixed(2)}).`
      );
      return;
    }

    try {
      setIsLoading(true);
      if (paymentEditIndex !== null) {
        await axios.put(`${ApiUrl}/sales_payment_history.php`, {
          id: newPayment.id,
          Sales_ID: newPayment.Sales_ID,
          Date: newPayment.Date,
          Pay_Type: newPayment.Pay_Type,
          Amount: newPayment.Amount,
        });
      } else {
        await axios.post(`${ApiUrl}/sales_payment_history.php`, newPayment);
      }

      setPaymentHistory((prev) => {
        const updatedHistory =
          paymentEditIndex !== null ? [...prev] : [...prev, newPayment];
        if (paymentEditIndex !== null)
          updatedHistory[paymentEditIndex] = newPayment;
        return updatedHistory;
      });

      resetPaymentForm();
      setPaymentEditIndex(null);
      toast.success(
        paymentEditIndex !== null
          ? "Payment updated successfully!"
          : "Payment added successfully!"
      );
    } catch (error) {
      console.error("Error updating/adding payment:", error);
      toast.error(error.message || "Failed to update/add payment");
    } finally {
      setIsLoading(false);
    }
  };

  const resetPaymentForm = () => {
    setPaymentForm({
      Date: new Date().toISOString().split("T")[0],
      Pay_Type: "",
      Amount: "",
    });
  };

  const handleEditPayment = (index) => {
    setPaymentForm({
      Date: paymentHistory[index].Date,
      Pay_Type: paymentHistory[index].Pay_Type,
      Amount: paymentHistory[index].Amount,
    });
    setPaymentEditIndex(index);
    setShowPaymentModal(true);
  };

  const handleDeletePayment = async (index) => {
    try {
      setIsLoading(true);
      const paymentId = paymentHistory[index].id;
      await axios.delete(`${ApiUrl}/sales_payment_history.php?id=${paymentId}`);
      const updatedPayments = paymentHistory.filter((_, i) => i !== index);
      setPaymentHistory(updatedPayments);
      toast.success("Payment deleted successfully!");
    } catch (error) {
      console.error("Error deleting payment:", error);
      toast.error(error.message || "Failed to delete payment");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/sales");
  };

  const handleSubmit = async () => {
    const errors = {};
    if (!salesData.Sales_ID) errors.Sales_ID = "Sales ID is required";
    if (!salesData.Purchase_Date)
      errors.Purchase_Date = "Sales date is required";
    if (!salesData.name) errors.name = "Customer name is required";
    if (salesItems.length === 0)
      errors.salesItems = "At least one sales item is required";

    const validSalesItems = salesItems.filter((item) =>
      validateHsnCode(item.hsn_code)
    );
    if (validSalesItems.length !== salesItems.length) {
      errors.salesItems = "Some items have invalid or missing HSN codes";
    }

    for (const item of validSalesItems) {
      const itemErrors = validateSalesItemForm(item);
      if (Object.keys(itemErrors).length > 0) {
        setFormErrors((prev) => ({ ...prev, ...itemErrors }));
        errors.salesItems = "Please correct errors in sales items";
      }
    }

    if (Object.keys(errors).length > 0) {
      toast.error(Object.values(errors).join(", "));
      return;
    }

    // Check if there are any changes to salesItems or paymentHistory
    const salesItemsChanged =
      JSON.stringify(validSalesItems) !== JSON.stringify(originalSalesItems);
    const paymentHistoryChanged = paymentHistory.some((payment, index) => {
      const originalPayment = originalSalesItems[index]?.paymentHistory || {};
      return JSON.stringify(payment) !== JSON.stringify(originalPayment);
    });

    if (!salesItemsChanged && !paymentHistoryChanged) {
      toast.info("No changes detected. No update required.");
      navigate("/sales");
      return;
    }

    let formattedPurchaseDate;
    try {
      formattedPurchaseDate = new Date(salesData.Purchase_Date)
        .toISOString()
        .split("T")[0];
      if (!formattedPurchaseDate || formattedPurchaseDate === "Invalid Date") {
        throw new Error("Invalid sales date format");
      }
    } catch (error) {
      toast.error("Invalid sales date format");
      setFormErrors((prev) => ({
        ...prev,
        Purchase_Date: "Invalid sales date format",
      }));
      return;
    }

    const payload = {
      id: Sales_ID,
      Sales_ID: salesData.Sales_ID,
      Purchase_Date: formattedPurchaseDate,
      name: salesData.name,
      mobile_number: salesData.mobile_number,
      GSTIN: salesData.GSTIN,
      Sub_Total: calculateSubtotal().toFixed(2),
      Gst_Amount: calculateGstAmount().toFixed(2),
      Net_total: parseFloat(salesData.Net_total),
      Paid_Amount: parseFloat(salesData.Paid_Amount),
      balance: parseFloat(salesData.balance),
      Sales_Items: validSalesItems.map((item) => ({
        id: item.id,
        Sales_ID: item.Sales_ID,
        branch_name: item.branch_name || "Default Branch",
        category: item.category,
        sub_category: item.sub_category,
        vehicle_type: item.vehicle_type,
        type: item.type,
        tyre_size: item.tyre_size,
        HSN_code: item.hsn_code, // Use HSN_code to match backend expectation
        sales_quantity: Number(item.sales_quantity),
        sales_rate: Number(item.sales_rate),
        sales_gst: isGstDisabled ? 0 : Number(item.sales_gst),
        tyre_number: item.tyre_numbers.join(","),
        Mrp: parseFloat(item.Mrp),
        rate_per: parseFloat(item.Mrp).toFixed(2),
      })),
      Payment_History: paymentHistory.map((payment) => ({
        id: payment.id,
        Sales_ID: salesData.Sales_ID,
        Date: payment.Date,
        Pay_Type: payment.Pay_Type,
        Amount: parseFloat(payment.Amount),
      })),
    };

    try {
      // setIsLoading(true);

      // const originalQtys = originalSalesItems.reduce((acc, item) => {
      //   if (validateHsnCode(item.hsn_code)) {
      //     const key = `${item.hsn_code}|${item.category}|${item.sub_category}`;
      //     acc[key] = parseInt(item.sales_quantity, 10) || 0;
      //   }
      //   return acc;
      // }, {});
      // const currentHsns = new Set(
      //   validSalesItems.map(
      //     (item) => `${item.hsn_code}|${item.category}|${item.sub_category}`
      //   )
      // );
      // const updates = [];

      // for (const item of validSalesItems) {
      //   if (!validateHsnCode(item.hsn_code)) {
      //     console.warn(`Skipping item with invalid hsn_code: ${item.hsn_code}`);
      //     continue;
      //   }

      //   const key = `${item.hsn_code}|${item.category}|${item.sub_category}`;
      //   const oldQty = originalQtys[key] || 0;
      //   const newQty = parseInt(item.sales_quantity, 10) || 0;
      //   const diff = newQty - oldQty;

      //   if (diff !== 0) {
      //     const stockItem = stockData.find(
      //       (s) =>
      //         s.hsn_code === item.hsn_code &&
      //         s.category === item.category &&
      //         s.subcategory === item.sub_category
      //     );
      //     if (!stockItem) {
      //       toast.error(
      //         `Stock not found for ${item.tyre_size} (${item.category} - ${item.sub_category})`
      //       );
      //       return;
      //     }
      //     const available = parseInt(stockItem.available_quantity, 10) || 0;
      //     if (diff > 0 && available < diff) {
      //       toast.error(
      //         `Insufficient stock for ${item.tyre_size} (${item.category} - ${item.sub_category}) - Available: ${available}, Needed additional: ${diff}`
      //       );
      //       return;
      //     }
      //     const newAvailable = available - diff;
      //     const newSoldQuantity =
      //       (parseInt(stockItem.sold_quantity, 10) || 0) + diff;

      //     updates.push({
      //       hsn_code: item.hsn_code,
      //       category: item.category,
      //       subcategory: item.sub_category,
      //       newAvailable,
      //       newSoldQuantity,
      //       stockItem,
      //     });
      //   }
      // }

      // for (const oldItem of originalSalesItems) {
      //   if (!validateHsnCode(oldItem.hsn_code)) {
      //     console.warn(
      //       `Skipping original item with invalid hsn_code: ${oldItem.hsn_code}`
      //     );
      //     continue;
      //   }

      //   const key = `${oldItem.hsn_code}|${oldItem.category}|${oldItem.sub_category}`;
      //   if (!currentHsns.has(key)) {
      //     const diff = 0 - (parseInt(oldItem.sales_quantity, 10) || 0);
      //     const stockItem = stockData.find(
      //       (s) =>
      //         s.hsn_code === oldItem.hsn_code &&
      //         s.category === oldItem.category &&
      //         s.subcategory === oldItem.sub_category
      //     );
      //     if (stockItem) {
      //       const available = parseInt(stockItem.available_quantity, 10) || 0;
      //       const newAvailable = available - diff;
      //       const newSoldQuantity =
      //         (parseInt(stockItem.sold_quantity, 10) || 0) + diff;

      //       updates.push({
      //         hsn_code: oldItem.hsn_code,
      //         category: oldItem.category,
      //         subcategory: oldItem.sub_category,
      //         newAvailable,
      //         newSoldQuantity,
      //         stockItem,
      //       });
      //     }
      //   }
      // }

      // for (const update of updates) {
      //   const {
      //     hsn_code,
      //     category,
      //     subcategory,
      //     newAvailable,
      //     newSoldQuantity,
      //     stockItem,
      //   } = update;

      //   if (!validateHsnCode(hsn_code)) {
      //     toast.error(`Invalid HSN code for ${stockItem.tyre_size}`);
      //     return;
      //   }

      // const stockPayload = {
      //   hsn_code,
      //   type: stockItem.type,
      //   tyre_size: stockItem.tyre_size,
      //   category,
      //   subcategory,
      //   purchase_rate: parseFloat(stockItem.purchase_rate) || 0,
      //   avg_purchase_rate:
      //     parseFloat(stockItem.avg_purchase_rate) ||
      //     parseFloat(stockItem.purchase_rate) ||
      //     0,
      //   mrp: stockItem.mrp || "0",
      //   available_quantity: newAvailable,
      //   total_purchase_quantity:
      //     parseInt(stockItem.total_purchase_quantity) || 0,
      //   sold_quantity: newSoldQuantity,
      //   total_purchases: parseInt(stockItem.total_purchases) || 1,
      // };

      // const stockExists = stockData.some(
      //   (stock) =>
      //     stock.hsn_code === hsn_code &&
      //     stock.category === category &&
      //     stock.subcategory === subcategory
      // );

      //   if (stockExists) {
      //     await axios.put(
      //       `${ApiUrl}/stock_data.php?hsn_code=${hsn_code}&category=${encodeURIComponent(
      //         category
      //       )}&subcategory=${encodeURIComponent(subcategory)}`,
      //       stockPayload,
      //       { headers: { "Content-Type": "application/json" } }
      //     );
      //   } else {
      //     await axios.post(`${ApiUrl}/stock_data.php`, stockPayload, {
      //       headers: { "Content-Type": "application/json" },
      //     });
      //   }

      //   setStockData((prev) =>
      //     prev.map((stock) =>
      //       stock.hsn_code === hsn_code &&
      //       stock.category === category &&
      //       stock.subcategory === subcategory
      //         ? {
      //             ...stock,
      //             available_quantity: newAvailable.toString(),
      //             sold_quantity: newSoldQuantity.toString(),
      //           }
      //         : stock
      //     )
      //   );
      // }

      await axios.put(`${ApiUrl}/sales_data.php`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success("Sales updated successfully!");
      navigate("/sales");
    } catch (error) {
      console.error("Error updating sales:", error);
      toast.error(
        error.message ||
        (error.response?.status === 404
          ? "Sales not found"
          : error.response?.data?.message || "Failed to update sales")
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrint = () => {
    navigate(`/invoice_sales/${Sales_ID}`);
  };

  const handleProductSubmit = async (e) => {
    e.preventDefault();
    if (
      !productData.category ||
      !productData.subcategory ||
      !productData.vehicle_type ||
      !productData.purchase_rate ||
      !productData.gst ||
      !productData.available_quantity ||
      !productData.mrp
    ) {
      toast.error("Please fill all required product fields");
      return;
    }

    if (
      isNaN(productData.purchase_rate) ||
      Number(productData.purchase_rate) <= 0 ||
      isNaN(productData.gst) ||
      Number(productData.gst) < 0 ||
      isNaN(productData.available_quantity) ||
      Number(productData.available_quantity) < 0 ||
      isNaN(productData.mrp) ||
      Number(productData.mrp) <= 0
    ) {
      toast.error("Rate, GST, MRP, and quantity must be valid numbers");
      return;
    }

    if (!validateHsnCode(productData.hsn_code)) {
      toast.error("Invalid HSN code for new product");
      return;
    }

    try {
      setIsLoading(true);
      const formData = {
        hsn_code: productData.hsn_code,
        category: productData.category,
        subcategory: productData.subcategory,
        vehicle_type: productData.vehicle_type,
        branch_name: productData.branch_name,
        brand_name: productData.brand_name,
        type: productData.type,
        tyre_size: productData.tyre_size,
        status: productData.status,
        purchase_rate: Number(productData.purchase_rate),
        gst: Number(productData.gst),
        available_quantity: Number(productData.available_quantity),
        mrp: Number(productData.mrp),
      };
      await axios.post(`${ApiUrl}/stock_data.php`, formData);
      const newProduct = { ...formData, hsn_code: formData.hsn_code };
      setStockData((prev) => [...prev, newProduct]);

      const updatedCategories = [...categoryTableData];
      const categoryIndex = updatedCategories.findIndex(
        (cat) => cat.category === formData.category
      );
      if (categoryIndex >= 0) {
        if (
          !updatedCategories[categoryIndex].subcategories.includes(
            formData.subcategory
          )
        ) {
          updatedCategories[categoryIndex].subcategories.push(
            formData.subcategory
          );
        }
      } else {
        updatedCategories.push({
          category: formData.category,
          subcategories: [formData.subcategory],
        });
      }
      setCategoryTableData(updatedCategories);

      setQuantities((prev) => ({
        ...prev,
        [`${newProduct.hsn_code}|${newProduct.category}|${newProduct.subcategory}`]: 0,
      }));
      fetchNextProductId();
      setShowModal(false);
      setProductData({
        hsn_code: "",
        category: "",
        subcategory: "",
        vehicle_type: "",
        branch_name: "Default Branch",
        brand_name: "",
        type: "",
        tyre_size: "",
        status: "Active",
        purchase_rate: "",
        gst: "",
        available_quantity: "",
        mrp: "",
      });
      toast.success("Product added successfully!");
    } catch (error) {
      console.error("Error adding product:", error);
      toast.error(error.message || "Failed to add product");
    } finally {
      setIsLoading(false);
    }
  };

  const filteredData = categoryTableData.filter((category) => {
    const query = searchQuery.toLowerCase().trim();
    if (!query) return true;
    const categoryMatches = category.category.toLowerCase().includes(query);
    const subCategoryMatches = category.subcategories.some((subCat) =>
      subCat.toLowerCase().includes(query)
    );
    const productMatches = stockData.some(
      (item) =>
        item.category === category.category &&
        (item.brand_name.toLowerCase().includes(query) ||
          item.type.toLowerCase().includes(query) ||
          item.tyre_size.toLowerCase().includes(query) ||
          item.subcategory.toLowerCase().includes(query))
    );
    return categoryMatches || subCategoryMatches || productMatches;
  });

  const getFilteredProducts = (categoryName) => {
    const query = searchQuery.toLowerCase().trim();
    return stockData.filter(
      (item) =>
        item.category === categoryName &&
        (!query ||
          item.brand_name.toLowerCase().includes(query) ||
          item.type.toLowerCase().includes(query) ||
          item.tyre_size.toLowerCase().includes(query) ||
          item.subcategory.toLowerCase().includes(query))
    );
  };

  useEffect(() => {
    if (searchQuery.trim()) {
      setExpandedCategories(
        filteredData.reduce(
          (acc, cat) => ({ ...acc, [cat.category]: true }),
          {}
        )
      );
    }
  }, [searchQuery, filteredData]);

  const clearSearch = () => setSearchQuery("");

  return (
    <div className="bg-white font-sans overflow-x-hidden">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />
      {error && (
        <div className="alert alert-danger mx-4" role="alert">
          {error}
        </div>
      )}
      {isLoading && <div className="text-center">Loading...</div>}
      <h2 className="m-0 fs-5 fw-semibold text-dark mx-1 mb-3">Update Sales</h2>
      <div className="row g-3">
        <div className="col-lg-3">
          <div className="card p-2 h-100">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="mb-0">Product List</h5>
              <button
                className="btn btn-sm btn-outline-primary"
                onClick={() => {
                  setShowModal(true);
                  fetchNextProductId();
                }}
                title="Add new product"
              >
                <Plus size={16} />
              </button>
            </div>
            <div className="mb-3">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search by category or tyre size"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                {searchQuery && (
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    type="button"
                    onClick={clearSearch}
                  >
                    ×
                  </button>
                )}
              </div>
              {searchQuery && (
                <small className="text-muted">
                  Showing {filteredData.length} categories
                </small>
              )}
            </div>
            {isLoading ? (
              <p>Loading...</p>
            ) : error ? (
              <p className="text-danger">{error}</p>
            ) : stockData.length === 0 || categoryTableData.length === 0 ? (
              <p className="text-center">No products available</p>
            ) : (
              <div className="table-responsive">
                <table
                  className="table table-bordered table-sm"
                  style={{ fontSize: "13px" }}
                >
                  <thead>
                    <tr>
                      <th></th>
                      <th>Products</th>
                      <th>Avl Qty</th>
                      <th>Sale Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((category, catIndex) => (
                      <React.Fragment key={category.category}>
                        <tr>
                          <td>
                            <button
                              className="btn btn-sm btn-outline-secondary p-1"
                              onClick={() => toggleCategory(category.category)}
                            >
                              {expandedCategories[category.category] ? (
                                <ChevronUp size={10} />
                              ) : (
                                <ChevronDown size={10} />
                              )}
                            </button>
                          </td>
                          <td colSpan="4" className="fw-bold">
                            {category.category || "Uncategorized"}
                          </td>
                        </tr>
                        {expandedCategories[category.category] &&
                          getFilteredProducts(category.category).map(
                            (item, index) => (
                              <tr key={item.hsn_code}>
                                <td></td>
                                <td>
                                  {item.subcategory}-{item.tyre_size || "N/A"} (
                                  {item.type || "N/A"} )-({item.Mrp})
                                </td>
                                <td>{item.available_quantity || 0}</td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <button
                                      className="btn btn-sm btn-outline-secondary px-2 py-1"
                                      onClick={() =>
                                        handleQuantityChange(item, "decrease")
                                      }
                                      disabled={
                                        quantities[
                                        `${item.hsn_code}|${item.category}|${item.subcategory}`
                                        ] === 0
                                      }
                                    >
                                      -
                                    </button>
                                    <span className="mx-2">
                                      {quantities[
                                        `${item.hsn_code}|${item.category}|${item.subcategory}`
                                      ] || 0}
                                    </span>
                                    <button
                                      className="btn btn-sm btn-outline-secondary px-2 py-1"
                                      onClick={() =>
                                        handleQuantityChange(item, "increase")
                                      }
                                      disabled={
                                        quantities[
                                        `${item.hsn_code}|${item.category}|${item.subcategory}`
                                        ] >=
                                        parseInt(
                                          item.available_quantity,
                                          10
                                        ) ||
                                        parseInt(
                                          item.available_quantity,
                                          10
                                        ) === 0
                                      }
                                    >
                                      +
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            )
                          )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        <div className="col-lg-6">
          <div className="card border h-100">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover mb-0 text-center">
                  <thead>
                    <tr style={{ backgroundColor: "#d3d3d3" }}>
                      {/* <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        S.No
                      </th> */}
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        Products
                      </th>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        Rate/per
                      </th>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        Qty
                      </th>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        Rate
                      </th>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        GST
                      </th>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        Amount
                      </th>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {console.log("Rendering salesItems:", salesItems)}
                    {salesItems.length > 0 ? (
                      salesItems.map((item, index) => {
                        // const gstRate = parseFloat(item.sales_gst || 0) / 100;
                        // const mrpIncludingGst = parseFloat(item.Mrp || 0);
                        // const baseMrp1 = (mrpIncludingGst * (1 + gstRate)).toFixed(2);
                        // const baseMrp2 = (baseMrp1 - mrpIncludingGst).toFixed(2);
                        // const baseMrp = (mrpIncludingGst - baseMrp2).toFixed(2);
                        // const totalAmount = (item.sales_quantity * mrpIncludingGst).toFixed(2);


                        const gstRate = parseFloat(item.sales_gst || 0) / 100;
                        const mrpIncludingGst = parseFloat(item.Mrp || 0);
                        const baseMrp1 = (mrpIncludingGst * (1 + gstRate)).toFixed(2);
                        const baseMrp2 = (baseMrp1 - mrpIncludingGst).toFixed(2);
                        const baseMrp = (mrpIncludingGst - baseMrp2).toFixed(2);
                        const totalAmount = (item.sales_quantity * mrpIncludingGst).toFixed(2);
                        return (
                          <React.Fragment key={item.id}>
                            <tr style={{ fontSize: "15px", fontWeight: "400" }}>
                              {/* <td>{index + 1}</td> */}
                              <td>{`${item.category} - ${item.sub_category} - ${item.tyre_size}`}</td>
                              <td>
                                <input
                                  type="tel"
                                  className="form-control form-control-sm"
                                  style={{ width: "80px" }}
                                  value={mrpIncludingGst}
                                  onChange={(e) =>
                                    handleSalesItemChange(index, "Mrp", e.target.value)
                                  }
                                  min="0"
                                  step="0.01"
                                />
                              </td>
                              <td>
                                <input
                                  type="tel"
                                  className={`form-control form-control-sm ${formErrors.sales_quantity &&
                                    index === editIndex
                                    ? "border-danger"
                                    : ""
                                    }`}
                                  value={item.sales_quantity}
                                  onChange={(e) =>
                                    handleSalesItemChange(
                                      index,
                                      "sales_quantity",
                                      e.target.value
                                    )
                                  }
                                  style={{ width: "50px" }}
                                />
                                {formErrors.sales_quantity &&
                                  index === editIndex && (
                                    <small className="text-danger">
                                      {formErrors.sales_quantity}
                                    </small>
                                  )}
                              </td>
                              <td>
                                <input
                                  type="tel"
                                  className={`form-control form-control-sm ${formErrors.Mrp && index === editIndex
                                    ? "border-danger"
                                    : ""
                                    }`}
                                  value={baseMrp}
                                  onChange={(e) => {
                                    const newBaseMrp =
                                      parseFloat(e.target.value) || 0;
                                    const newMrp = (
                                      newBaseMrp *
                                      (1 + gstRate)
                                    ).toFixed(2);
                                    handleSalesItemChange(index, "Mrp", newMrp);
                                  }}
                                  style={{ width: "100px" }}
                                />
                                {formErrors.Mrp && index === editIndex && (
                                  <small className="text-danger">
                                    {formErrors.Mrp}
                                  </small>
                                )}
                              </td>
                              <td>
                                <input
                                  type="tel"
                                  className={`form-control form-control-sm ${formErrors.sales_gst && index === editIndex
                                    ? "border-danger"
                                    : ""
                                    }`}
                                  value={isGstDisabled ? 0 : item.sales_gst}
                                  onChange={(e) =>
                                    handleSalesItemChange(
                                      index,
                                      "sales_gst",
                                      e.target.value
                                    )
                                  }
                                  style={{ width: "50px" }}
                                  disabled={isGstDisabled}
                                />
                                {formErrors.sales_gst &&
                                  index === editIndex && (
                                    <small className="text-danger">
                                      {formErrors.sales_gst}
                                    </small>
                                  )}
                              </td>
                              <td>₹{totalAmount}</td>
                              <td>
                                <div className="d-flex gap-2">
                                  {/* <button
                                    onClick={() => handleEditSalesItem(index)}
                                    className="border-0 bg-transparent text-muted"
                                  >
                                    <Edit2 size={16} />
                                  </button> */}
                                  <button
                                    onClick={() => handleDeleteSalesItem(index)}
                                    className="border-0 bg-transparent text-muted"
                                  >
                                    <Trash2 size={16} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan="7">
                                <div className="card p-2 bg-light border rounded mb-2">
                                  {item.tyre_numbers.map((num, tyreIdx) => (
                                    <div
                                      key={tyreIdx}
                                      className="row align-items-center mb-2"
                                    >
                                      <div className="col-md-5 text-start">
                                        <strong>
                                          Tyre Number {tyreIdx + 1}
                                        </strong>
                                      </div>
                                      <div className="col-md-7">
                                        <input
                                          type="text"
                                          className={`form-control form-control-sm ${formErrors.tyre_number &&
                                            index === editIndex &&
                                            !num.trim()
                                            ? "border-danger"
                                            : ""
                                            }`}
                                          value={num}
                                          onChange={(e) =>
                                            handleTyreNumberChange(
                                              index,
                                              tyreIdx,
                                              e.target.value
                                            )
                                          }
                                          placeholder={`Enter Tyre Number ${tyreIdx + 1
                                            }`}
                                          required
                                        />
                                      </div>
                                    </div>
                                  ))}
                                  {formErrors.tyre_number &&
                                    index === editIndex && (
                                      <small className="text-danger">
                                        {formErrors.tyre_number}
                                      </small>
                                    )}
                                </div>
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No sales items added
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>



        <div className="col-lg-3">
          <div className="card " style={{ backgroundColor: "#fff0f5" }}>
            <div className="row g-2 p-3">
              <div className="col-12">
                <div className="row g-2 mb-2">
                  <div className="col-md-5">
                    <label
                      className="form-label small fw-medium"
                      style={{ fontSize: "14px" }}
                    >
                      Invoice No
                    </label>
                  </div>
                  <div className="col-md-7">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="Sales_ID"
                      value={salesData.Sales_ID}
                      readOnly
                      style={{
                        padding: "10px",
                        fontSize: "14px",
                        background: "white",
                      }}
                    />
                  </div>
                </div>


                <div className="row g-2">
                  <div className="col-md-5">
                    <label
                      className="form-label small fw-medium"
                      style={{ fontSize: "14px" }}
                    >
                      Date <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-md-7">
                    <input
                      type="date"
                      className={`form-control form-control-sm ${formErrors.Purchase_Date ? "border-danger" : ""
                        }`}
                      name="Purchase_Date"
                      value={salesData.Purchase_Date}
                      onChange={handleSalesDataChange}
                      style={{
                        padding: "10px",
                        fontSize: "14px",
                        background: "white",
                      }}
                      required
                    />
                    {formErrors.Purchase_Date && (
                      <div className="text-danger small">
                        {formErrors.Purchase_Date}
                      </div>
                    )}
                  </div>
                </div>

              </div>
            </div>

          </div>



          <div className="card mt-2" style={{ backgroundColor: "#fff0f5" }}>
            <div className="row g-2 p-3">
              <div className="col-12">
                <div className="row g-2 mb-2">
                  <div className="col-md-5">
                    <label
                      className="form-label small fw-medium"
                      style={{ fontSize: "14px" }}
                    >
                      Customer <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-md-7">
                    <input
                      type="text"
                      className={`form-control form-control-sm ${formErrors.name ? "border-danger" : ""
                        }`}
                      name="name"
                      value={salesData.name}

                      placeholder="Enter Customer Name"
                      style={{ padding: "10px", fontSize: "14px" }}
                      required
                    />
                    {formErrors.name && (
                      <div className="text-danger small">{formErrors.name}</div>
                    )}
                  </div>
                </div>
                <div className="row g-2 mb-2">
                  <div className="col-md-5">
                    <label
                      className="form-label small fw-medium"
                      style={{ fontSize: "14px" }}
                    >
                      Mobile Number
                    </label>
                  </div>
                  <div className="col-md-7">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="mobile_number"
                      value={salesData.mobile_number}
                      readOnly
                      style={{
                        padding: "10px",
                        fontSize: "14px",
                        background: "white",
                      }}
                    />
                  </div>
                </div>

                {salesData.GSTIN && (
                  <div className="row g-2 mb-2">
                    <div className="col-md-5">
                      <label
                        className="form-label small fw-medium"
                        style={{ fontSize: "14px" }}
                      >
                        GSTIN
                      </label>
                    </div>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="GSTIN"
                        value={salesData.GSTIN}
                        readOnly
                        style={{
                          padding: "10px",
                          fontSize: "14px",
                          background: "white",
                        }}
                      />
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>



          <div className="card mt-2 " style={{ backgroundColor: "#fff0f5" }}>
            <div className="row g-2 p-3">
              <div className="col-12">
                <div className="row g-2 mb-1">
                  <div className="col-md-5">
                    <label
                      className="form-label small fw-semibold text-muted"
                      style={{ fontSize: "14px" }}
                    >
                      Sub Total
                    </label>
                  </div>
                  <div className="col-md-7">
                    <input
                      className="form-control form-control-sm bg-light"
                      value={`${salesData.Sub_Total}`}
                      disabled
                      style={{ padding: "8px", fontSize: "14px" }}
                    />
                  </div>
                </div>


                <div className="row g-2 mb-1">
                  <div className="col-md-5">
                    <label
                      className="form-label small fw-semibold text-muted"
                      style={{ fontSize: "14px" }}
                    >
                      GST
                    </label>
                    <input
                      type="checkbox"
                      checked={isGstDisabled}
                      onChange={handleGstCheckboxChange}
                      title="Disable GST for all items"
                    />
                  </div>
                  <div className="col-md-7">
                    <input
                      className="form-control form-control-sm bg-light"
                      value={`${salesData.Gst_Amount}`}
                      disabled
                      style={{ padding: "8px", fontSize: "14px" }}
                    />
                  </div>
                </div>



                <div className="row g-2 mb-1">
                  <div className="col-md-5">
                    <label
                      className="form-label small fw-semibold text-muted"
                      style={{ fontSize: "14px" }}
                    >
                      Net Total
                    </label>
                  </div>
                  <div className="col-md-7">
                    <input
                      className="form-control form-control-sm bg-light"
                      value={`${salesData.Net_total}`}
                      disabled
                      style={{ padding: "8px", fontSize: "14px" }}
                    />
                  </div>
                </div>



                <div className="row g-2 mb-1">
                  <div className="col-md-5">
                    <label
                      className="form-label small fw-semibold text-muted"
                      style={{ fontSize: "14px" }}
                    >
                      Paid Amount
                    </label>
                  </div>
                  <div className="col-md-7">
                    <input
                      className="form-control form-control-sm bg-light"
                      value={`${salesData.Paid_Amount}`}
                      disabled
                      style={{ padding: "8px", fontSize: "14px" }}
                    />
                  </div>
                </div>




                <div className="row g-2 mb-1">
                  <div className="col-md-5">
                    <label
                      className="form-label small fw-semibold text-muted"
                      style={{ fontSize: "14px" }}
                    >
                      Balance
                    </label>
                  </div>
                  <div className="col-md-7">
                    <input
                      className="form-control form-control-sm bg-light"
                      value={`${salesData.balance}`}
                      disabled
                      style={{ padding: "8px", fontSize: "14px" }}
                    />
                  </div>
                </div>
                <div className="d-flex flex-column flex-md-row gap-1 mt-2">
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => setShowPaymentModal(true)}
                  >
                    Add Payment
                  </button>
                  <button
                    className="btn btn-success btn-sm"
                    onClick={handleSubmit}
                    disabled={isLoading}
                  >
                    Update
                  </button>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={handlePrint}
                  >
                    Print
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>

              </div>
            </div>
          </div>


        </div>

      </div>

      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{
          display: showModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content rounded"
            style={{ backgroundColor: "#fff0f5" }}
          >
            <div className="modal-header bg-pink-light border-bottom-0">
              <h5 className="modal-title m-0 fw-semibold">Add Product</h5>
              <button
                className="btn-close"
                onClick={() => setShowModal(false)}
                disabled={isLoading}
              ></button>
            </div>
            <div className="modal-body bg-light">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    HSN Code <span className="text-danger">*</span>
                  </label>
                  {isLoading ? (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={productData.hsn_code}
                      readOnly
                    />
                  )}
                  {productData.hsn_code.startsWith("TEMP-") && (
                    <small className="text-warning">
                      Temporary HSN code used due to API failure.
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Category <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.category}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        category: e.target.value,
                        subcategory: "",
                      })
                    }
                    required
                  >
                    <option value="">Select Category</option>
                    {categoryTableData.map((category) => (
                      <option key={category.category} value={category.category}>
                        {category.category}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Subcategory <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.subcategory}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        subcategory: e.target.value,
                      })
                    }
                    disabled={!productData.category}
                    required
                  >
                    <option value="">Select Subcategory</option>
                    {productData.category &&
                      categoryTableData
                        .find((cat) => cat.category === productData.category)
                        ?.subcategories.map((subcat) => (
                          <option key={subcat} value={subcat}>
                            {subcat}
                          </option>
                        ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Vehicle Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.vehicle_type}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        vehicle_type: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="">Select Vehicle Type</option>
                    <option value="Car">Car</option>
                    <option value="Bike">Bike</option>
                    <option value="Truck">Truck</option>
                    <option value="Bus">Bus</option>
                    <option value="Tractor">Tractor</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Branch Name
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={productData.branch_name}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        branch_name: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Brand Name
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.brand_name}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        brand_name: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Brand Name</option>
                    <option value="MRF">MRF</option>
                    <option value="CEAT">CEAT</option>
                    <option value="Apollo">Apollo</option>
                    <option value="JK Tyre">JK Tyre</option>
                    <option value="Bridgestone">Bridgestone</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">Type</label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.type}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        type: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Type</option>
                    <option value="Radial">Radial</option>
                    <option value="Bias">Bias</option>
                    <option value="Tubeless">Tubeless</option>
                    <option value="Tube Type">Tube Type</option>
                    <option value="Solid">Solid</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Tyre Size
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={productData.tyre_size}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        tyre_size: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Rate <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    value={productData.purchase_rate}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        purchase_rate: e.target.value,
                      })
                    }
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    GST <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    value={productData.gst}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        gst: e.target.value,
                      })
                    }
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    MRP <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    value={productData.mrp}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        mrp: e.target.value,
                      })
                    }
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Available Quantity <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    value={productData.available_quantity}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        available_quantity: e.target.value,
                      })
                    }
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Product Status
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.status}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        status: e.target.value,
                      })
                    }
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="modal-footer border-top-0">
              <button
                className="btn btn-sm btn-danger"
                onClick={() => setShowModal(false)}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                className="btn btn-sm btn-success"
                onClick={handleProductSubmit}
                disabled={isLoading}
              >
                {isLoading ? "Adding..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${showPaymentModal ? "show" : ""}`}
        style={{
          display: showPaymentModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content" style={{ backgroundColor: "#fff0f5" }}>
            <div className="modal-header bg-pink-light border-bottom-0">
              <h5 className="modal-title fw-semibold m-0">
                {paymentEditIndex !== null ? "Edit Payment" : "Add Payment"}
              </h5>
              <button
                className="btn-close"
                onClick={() => {
                  setShowPaymentModal(false);
                  resetPaymentForm();
                  setPaymentEditIndex(null);
                }}
                disabled={isLoading}
              ></button>
            </div>
            <div className="modal-body">
              <div className="container-fluid">
                <div className="row g-3 mb-1">
                  <div className="col-md-6">
                    <label className="form-label fw-medium small">
                      Balance
                      <input
                        className="form-control form-control-sm mt-1 text-success"
                        value={`${Number(salesData.balance).toFixed(2)}`}
                        disabled
                      />
                    </label>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-medium small">
                      Paid
                      <input
                        className="form-control form-control-sm mt-1 text-success"
                        value={`${Number(salesData.Paid_Amount).toFixed(2)}`}
                        disabled
                      />
                    </label>
                  </div>
                </div>
                <div className="col-md-12 mb-3">
                  <label className="form-label small fw-medium">
                    Payment Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="Date"
                    value={paymentForm.Date}
                    onChange={handlePaymentChange}
                    disabled={isLoading}
                  />
                </div>
                <div className="row g-3 mb-3 align-items-end">
                  <div className="col-md-5">
                    <label className="form-label fw-medium small">
                      Amount
                      <input
                        className="form-control form-control-sm mt-1"
                        name="Amount"
                        type="number"
                        value={paymentForm.Amount}
                        onChange={handlePaymentChange}
                        placeholder="Enter Amount"
                        disabled={isLoading}
                        min="0"
                      />
                    </label>
                  </div>
                  <div className="col-md-5">
                    <label className="form-label fw-medium small">
                      Pay Type
                      <select
                        className="form-select form-select-sm mt-1"
                        name="Pay_Type"
                        value={paymentForm.Pay_Type}
                        onChange={handlePaymentChange}
                        disabled={isLoading}
                      >
                        <option value="">Select Pay Type</option>
                        <option value="Cash">Cash</option>
                        <option value="Gpay">Gpay</option>
                        <option value="Phonepay">Phonepay</option>
                        <option value="Paytm">Paytm</option>
                        <option value="Credit">Credit</option>
                        <option value="Debit">Debit</option>
                      </select>
                    </label>
                  </div>
                  <div className="col-md-2">
                    <button
                      className="btn btn-success btn-sm mb-2 w-100"
                      onClick={handleAddPayment}
                      disabled={isLoading}
                    >
                      {paymentEditIndex !== null ? "Update" : "Add"}
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <h6 className="mb-2">Payment History</h6>
                    <table className="table table-bordered table-sm text-center">
                      <thead className="small fw-light">
                        <tr>
                          <th>S.No</th>
                          <th>Date</th>
                          <th>Pay Type</th>
                          <th>Amount</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paymentHistory.length > 0 ? (
                          paymentHistory.map((payment, index) => (
                            <tr key={payment.id}>
                              <td>{index + 1}</td>
                              <td>{payment.Date}</td>
                              <td>{payment.Pay_Type}</td>
                              <td>{Number(payment.Amount).toFixed(2)}</td>
                              <td>
                                <div className="d-flex gap-2 justify-content-center">
                                  <button
                                    className="btn btn-sm btn-primary"
                                    onClick={() => handleEditPayment(index)}
                                    disabled={isLoading}
                                  >
                                    <Edit2 size={16} />
                                  </button>{" "}
                                  <button
                                    className="btn btn-sm btn-danger"
                                    onClick={() => handleDeletePayment(index)}
                                    disabled={isLoading}
                                  >
                                    <Trash2 size={16} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No payment history available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer border-top-0">
              <button
                className="btn btn-sm btn-secondary"
                onClick={() => {
                  setShowPaymentModal(false);
                  resetPaymentForm();
                  setPaymentEditIndex(null);
                }}
                disabled={isLoading}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateSales;
